module.exports = __webpack_public_path__ + "static/img/gallery_2.ca650f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/gallery_2.png
// module id = wFzq
// module chunks = 1